/* eslint-disable max-len */
import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert } from 'components';
import { Card, CardContent, CardActions, Grid, Divider, TextField, Accordion, AccordionSummary, AccordionDetails, Typography, colors } from '@mui/material';
import { MopRanReportUploadFile } from '../../actions/MopRanReportActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const MopRanReportUpload = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const user = useSelector(state => state.session.user);

	const _IncidentCellListUpload = file => {
		dispatch(MopRanReportUploadFile(file[0], user.id));
	};

	return (
		<Page className={classes.root}>
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						{/* <Typography variant="body1" color="text.secondary">
							This module its only to upload Incident Cell List file and generate a report.
						</Typography>
						<br /> */}
						<Divider />
						<FilesDropzone upload={_IncidentCellListUpload} multiple={false} />
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default MopRanReportUpload;
